import React, { useMemo } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { useFormikContext } from 'formik';

// FUNCTIONS
import { dollarsToNumber, sleep } from 'functions.js';

// GLOBAL CONTEXT
import useRecordView from 'helpers/getRecordView';

// CONTEXT
import { useAMFIProducts } from '../helpers/AMFIProductsProvider';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import FormRow from '../tools/FormRow';
import FormCol from '../tools/FormCol';

// MAIN COMPONENT
const FIProducts = () => {
  const { values, setFieldValue, setFieldError, initialValues } = useFormikContext() || {};
  const { isSales } = useRecordView();

  const { aryDealerAMFinance } = useMemo(() => values || {}, [values]);

  const { amProducts, fiProducts, readOnly } = useAMFIProducts();

  // RENDER
  return fiProducts?.length
    ? fiProducts.map((product, fiProductsIndex) => {
        const {
          is_checked, //
          item_name,
          product_code
        } = product;
        const i = fiProductsIndex + (amProducts?.length || 0);
        const isReadOnly = !readOnly && !is_checked;

        return (
          <Form.Col key={i}>
            <FormRow>
              <FormCol cols={{ xs: 24, md: 5 }}>
                <Form.Label className={clsx(!isSales && 'justify-content-end')}>{item_name}</Form.Label>
              </FormCol>
              <FormCol cols={{ xs: 24, md: 3 }}>
                {product_code ? <Form.PlainText value={product_code} /> : null}
              </FormCol>
              <FormCol cols={{ xs: 24, md: 2 }}>
                {readOnly ? null : (
                  <Form.Checkbox
                    name={`aryDealerAMFinance[${i}].is_checked`}
                    checked={aryDealerAMFinance?.[i]?.is_checked}
                    containerClassName="align-items-start mt-3"
                    onChange={async ({ target: { checked } }) => {
                      setFieldValue(`aryDealerAMFinance[${i}].cancel_comment`, '');

                      // If initial product checked has changed
                      if (initialValues?.aryDealerAMFinance?.[i].is_checked !== checked) {
                        setFieldValue(`aryDealerAMFinance[${i}].isUpdated`, true);
                      }

                      if (checked) {
                        setFieldValue(`aryDealerAMFinance[${i}].is_checked`, true);
                      } else {
                        setFieldValue(`aryDealerAMFinance[${i}].is_checked`, false);
                        const item_gross = `aryDealerAMFinance[${i}].item_gross`;

                        // Clear any errors
                        setFieldError(item_gross, undefined);

                        await sleep(200);

                        // Clear product values
                        setFieldValue(item_gross, '');
                      }
                    }}
                  />
                )}
              </FormCol>
              <FormCol cols={{ xs: 24, md: 5 }}>
                <Form.Control
                  name={`aryDealerAMFinance[${i}].item_gross`}
                  schema="dollars"
                  onChange={({ target: { value } }) => {
                    // If initial product value has changed
                    if (initialValues?.aryDealerAMFinance?.[i].is_checked) {
                      if (initialValues?.aryDealerAMFinance[i].item_gross !== dollarsToNumber(value))
                        setFieldValue(`aryDealerAMFinance[${i}].isUpdated`, true);
                    }
                  }}
                  readOnly={isReadOnly}
                  required={!isReadOnly}
                  plaintext={readOnly}
                />
              </FormCol>
              <FormCol cols={{ xs: 24, md: 9 }} />
            </FormRow>
          </Form.Col>
        );
      })
    : null;
};

// EXPORT
export default FIProducts;
